/**
 * Indica si el entorno parece móvil/tablet táctil (instalación PWA solo ahí).
 */
export function isMobileDevice() {
  if (typeof window === "undefined") return false;
  const narrow = window.matchMedia("(max-width: 768px)").matches;
  const coarse =
    window.matchMedia("(pointer: coarse)").matches ||
    navigator.maxTouchPoints > 0;
  return narrow && coarse;
}
